// extracted by mini-css-extract-plugin
var _1 = "bpl__leaderboard__k3m6l";
var _2 = "bpl__leaderboard__header__OLvon";
var _3 = "bpl__leaderboard__header__position__Y9um5";
var _4 = "bpl__leaderboard__header__score__HYqOb";
var _5 = "bpl__leaderboard__header__username__WUL7K";
var _6 = "bpl__leaderboard__list__TZUo8";
export { _1 as "leaderboard", _2 as "leaderboard__header", _3 as "leaderboard__header__position", _4 as "leaderboard__header__score", _5 as "leaderboard__header__username", _6 as "leaderboard__list" }
